/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  WorkloadTokenEndpoint,
  WorkloadTokenEndpoint$inboundSchema,
} from "./workloadtokenendpoint.js";

export type WorkloadTokenEndpoints = {
  /**
   * Organization-level issuers first, then by project name and issuer slug.
   */
  items: Array<WorkloadTokenEndpoint>;
};

/** @internal */
export const WorkloadTokenEndpoints$inboundSchema: z.ZodMiniType<
  WorkloadTokenEndpoints,
  unknown
> = z.object({
  items: z.array(WorkloadTokenEndpoint$inboundSchema),
});

export function workloadTokenEndpointsFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadTokenEndpoints, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadTokenEndpoints$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadTokenEndpoints' from JSON`,
  );
}
